$(function() {
	const priceSlider = new Swiper('.price-slider', {
		slidesPerView: 'auto',
		speed: 1200,
		breakpoints: {
			769: {
				enabled: false,
			}
		},
		pagination: {
			el: '.price-pagination',
		},
	});
})